import { Routes } from '@angular/router';

import { AuthGuard } from '@auth0/auth0-angular';

import { AUTH_ROUTES } from './auth/auth.routes';
import { adminGuard } from './auth/guards/admin.guard';
import { AppShellComponent } from './shared/core/app-shell/app-shell.component';

/** Every page in the shell is only for a SmartHead administrator (`adminGuard`) */
const ADMIN_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'profile',
    pathMatch: 'full'
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.routes').then(m => m.PROFILE_ROUTES)
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.routes').then(m => m.USER_ROUTES)
  },
  {
    path: 'consolidation',
    loadChildren: () => import('./consolidation/consolidation.routes').then(m => m.CONSOLIDATION_ROUTES)
  },
  {
    path: 'audit-log',
    title: 'Audit log',
    loadComponent: () => import('./audit-log/pages/audit-log-page/audit-log-page.component').then(m => m.AuditLogPageComponent)
  },
  {
    path: 'link-shortener',
    title: 'Link shortener',
    loadComponent: () => import('./link-shortener/pages/link-shortener-page/link-shortener-page.component').then(m => m.LinkShortenerPageComponent)
  },
  {
    path: 'ml',
    title: 'ML',
    loadComponent: () => import('./ml/pages/ml-page/ml-page.component').then(m => m.MlPageComponent)
  },
  // links to the previous version of the pages
  {
    path: 'dashboard',
    redirectTo: 'audit-log'
  },
  {
    path: 'subscription/profile/:profileId',
    redirectTo: 'profile/:profileId'
  },
  {
    path: 'subscription',
    redirectTo: 'profile'
  },
  {
    path: '**',
    redirectTo: ''
  }
];

/**
 * Main application routing
 */
export const APP_ROUTES: Routes = [
  ...AUTH_ROUTES,
  {
    path: '',
    canActivate: [
      AuthGuard,
      adminGuard
    ],
    component: AppShellComponent,
    children: ADMIN_ROUTES
  }
];
